import styled from "styled-components/macro";

export const OverviewWrapper = styled.div`
  min-height: 100%;
  background-color: ${(props) => props.theme.colors.bgPage};
  padding: 40px;

  @media ${(props) => props.theme.media.tablet} {
    flex-wrap: wrap;
    padding: 20px;
  }

  @media ${(props) => props.theme.media.phone} {
    flex-wrap: wrap;
    padding: 20px;
  }
`;

export const AdditionalInfoWrapper = styled.div`
  flex-basis: 49%;
  max-width: 582px;

  @media ${(props) => props.theme.media.tablet} {
    flex-basis: auto;
    max-width: none;
  }

  @media ${(props) => props.theme.media.phone} {
    flex-basis: auto;
    max-width: none;
  }
`;

export const InfoWithIconWrapper = styled.div<{
  margin?: string | 0;
  isCentered?: boolean;
}>`
  margin: ${({ margin }) => margin ?? "0 0 2rem"};
  display: flex;

  svg {
    margin-left: 0;
    margin-right: 0.5rem;
    min-width: 1.5rem;
    height: 1.5rem;
    color: ${({ theme }) => theme.colors.midGrey};
    align-self: ${({ isCentered }) => (!isCentered ? "flex-start" : "center")};
  }
`;
